/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import { Button } from 'react-bootstrap';
import { CLOSE } from '../../const';

class FlagModal extends React.Component {
  render() {
    return (
      <div id="flag-modal">
        {this.props.content}
        <hr className="edit-modal-divider" />
        <div id="flag-modal-close">
          <Button onClick={() => this.props.hide()}>{CLOSE}</Button>
        </div>
      </div>
    );
  }
}

export default FlagModal;
